module.exports = __webpack_public_path__ + "img/bell-minus.c750cb1f.svg";